/* eslint-disable no-unused-vars */
import {React, useState} from 'react';
import styled from 'styled-components';
import Sidebar from './components/Sidebar';
import Login from './components/Login';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import WeeklyPicks from './pages/WeeklyPicks';
import SharedWeeklyPicks from './pages/SharedWeeklyPicks';
import Home from './pages/Home';
import { ThemeProvider } from 'styled-components';
import { lightTheme, darkTheme } from './theme/theme';

const AppContainer = styled.div`
  text-align: center;
  background-color: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.text};
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const AppHeader = styled.div`
  background-color: ${props => props.theme.colors.background};
  padding: 20px;
  border-bottom: 1px solid ${props => props.theme.colors.borderColor};
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;

  h1 {
    text-align: center;
    margin: 0;
    color: ${props => props.theme.colors.text};
    flex: 1;
  }
`;

const PageWrap = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
`;

const HeaderContent = () => {
  const location = useLocation();
  
  let headingText = '';
  if (location.pathname.includes('/weekly-picks')) {
    headingText = 'Weekly Picks';
  }
  
  return (
    <>
      <div></div>
      <h1>{headingText}</h1>
      <Login />
    </>
  );
};

function App() {
  const [theme, setTheme] = useState('dark');

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  }

  return (
    <ThemeProvider theme={theme === 'light' ? lightTheme : darkTheme}>
      <AppContainer>
        <BrowserRouter>
          <AppHeader id="outer-container">
            <HeaderContent />
          </AppHeader>
          <Sidebar pageWrapId="page-wrap" outerContainerId="outer-container" theme={theme === 'light' ? lightTheme : darkTheme} />
          <PageWrap id="page-wrap">
            <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/weekly-picks" element={<WeeklyPicks />} />
            <Route path="/weekly-picks/:userId" element={<SharedWeeklyPicks />} />
            </Routes>
          </PageWrap>
        </BrowserRouter>
      </AppContainer>
    </ThemeProvider>
  )
}

export default App;